import { render, staticRenderFns } from "./personal-details.vue?vue&type=template&id=36535ead&scoped=true&"
import script from "./personal-details.vue?vue&type=script&lang=js&"
export * from "./personal-details.vue?vue&type=script&lang=js&"
import style0 from "./personal-details.vue?vue&type=style&index=0&id=36535ead&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36535ead",
  null
  
)

export default component.exports